import * as actionTypes from './actionTypes';

// Init state
export const mainState = {
  init: false,
  isLoading: false,
  isLadingPage: true,
  error: null,
  modal: {
    openModalKey: null,
    data: {},
  },
  mainList: [],
  sortedList: [],
};

export const mainReducer = (state, action) => {
  const { payload } = action;
  switch (action.type) {
  case actionTypes.NEW_TICKET:
    return {
      ...state,
      isLoading: true,
    };
  case actionTypes.NEW_TICKET_INIT:
    return {
      ...state,
      init: true,
      isLadingPage: false,
      isLoading: false,
      mainList: payload.data,
      sortedList: payload.data,
    };
  case actionTypes.NEW_TICKET_ERROR:
    return {
      ...state,
      isLadingPage: false,
      isLoading: false,
      error: payload.error,
    };
  case actionTypes.NEW_TICKET_CHANGE_POSITION_START:
    return {
      ...state,
      sortedList: payload.list,
    }
  case actionTypes.NEW_TICKET_CHANGE_POSITION_STOP:
    return {
      ...state,
      sortedList: state.mainList,
    }
  case actionTypes.NEW_TICKET_CHANGE_POSITION:
    return {
      ...state,
      isLoading: true,
      mainList: payload.list,
      sortedList: payload.list,
    };
  case actionTypes.NEW_TICKET_OPEN_MODAL:
    return {
      ...state,
      modal: {
        ...state.modal,
        openModalKey: payload.modalKey,
        data: payload.data,
      },
    }
  case actionTypes.NEW_TICKET_CLOSE_MODAL:
    return {
      ...state,
      modal: {
        ...state.modal,
        openModalKey: null,
        data: {},
      },
    }
  default:
    throw new Error();
  }
};
